var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Gear_Icon",
    "data-name": "Gear Icon",
    d: "M365,154.823V150.23l-2.812-.47a8.782,8.782,0,0,0-.885-2.14l1.667-2.3-3.229-3.288-2.344,1.618a10.867,10.867,0,0,0-2.135-.887L354.792,140h-4.583l-.469,2.818a9.69,9.69,0,0,0-2.135.887l-2.292-1.618-3.281,3.236,1.667,2.3a10.164,10.164,0,0,0-.885,2.192L340,150.23v4.593l2.813.47a9.73,9.73,0,0,0,.885,2.14l-1.667,2.349,3.229,3.236,2.344-1.67a10.117,10.117,0,0,0,2.188.887L350.26,165h4.583l.469-2.818a10.862,10.862,0,0,0,2.135-.887l2.344,1.67,3.229-3.236-1.667-2.349a9.735,9.735,0,0,0,.885-2.14Zm-12.5,2.505a4.8,4.8,0,1,1,4.792-4.8A4.784,4.784,0,0,1,352.5,157.328Z",
    transform: "translate(-340 -140)",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.1a3db348780b4e7a7ea1961f5a7530f3.svg";
export { ForwardRef as ReactComponent };